import GameModel from "../../../core/src/model/GameModel";
import GetGameRequest from "./GetGameRequest";
import VendorModel from "../../model/VendorModel";
import Utils from "../../../core/src/utils/Utils";

export default class ClosePlayRequest extends GetGameRequest {
  get requestData(): any {
    let userId = GameModel?.playerConfig?.userId || undefined;
    return {
      "action": "closePlay",
      "gameId":  GameModel.apiConfig.gameId,
      "userId": userId,
      "authToken": GameModel.authToken,
      "currency": GameModel.currency,
      "casino": GameModel.casino,
      "sessionId": GameModel.sessionID,
      "playId": VendorModel.playId,
      'serverVersion': GameModel.apiConfig.serverVersion,
      'gameVersion': Utils.isNullOrWhiteSpace(GameModel.apiConfig.gameVersion) ? GameModel?.gameVersion : GameModel.apiConfig.gameVersion,
      'deviceInfo': Utils.getDeviceInfo(),
      "playerToken": GameModel.playerToken
    }
  }

}